/**
 * Matches Keycloak realm GRC passwordPolicy:
 * length(12) + upperCase(1) + lowerCase(1) + digits(1) + specialChars(1)
 * + notUsername + notEmail
 * specials allowed by realm regex: @ $ ! % * ? &
 */

const SPECIAL_RE = /[@$!%*?&]/

export type PasswordRules = {
  len: boolean
  upper: boolean
  lower: boolean
  num: boolean
  sym: boolean
  notUsername: boolean
  notEmail: boolean
}

export function evaluatePasswordRules(
  password: string,
  opts?: { username?: string; email?: string }
): PasswordRules {
  const pw = password || ''
  const username = String(opts?.username || '').trim().toLowerCase()
  const email = String(opts?.email || '').trim().toLowerCase()
  const pwLower = pw.toLowerCase()

  return {
    len: pw.length >= 12,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    num: /\d/.test(pw),
    sym: SPECIAL_RE.test(pw),
    notUsername: !username || pwLower !== username,
    notEmail: !email || pwLower !== email,
  }
}

export function isPasswordPolicyMet(
  password: string,
  opts?: { username?: string; email?: string }
): boolean {
  const r = evaluatePasswordRules(password, opts)
  return Object.values(r).every(Boolean)
}

export function passwordStrengthScore(password: string): number {
  const r = evaluatePasswordRules(password)
  return [r.len, r.upper && r.lower, r.num, r.sym].filter(Boolean).length
}
